import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";

export const WalkthroughBackButton = memo(function WalkthroughBackButton({
  stepIndex,
  back,
  dismiss,
}: {
  stepIndex: number;
  back(): void;
  dismiss(): void;
}) {
  const isFirst = stepIndex === 0;

  return (
    <RedoButton
      hierarchy="tertiary"
      onClick={isFirst ? dismiss : back}
      size="sm"
      text={isFirst ? "Skip" : "Back"}
    />
  );
});

export const WalkthroughNavButtons = memo(function WalkthroughNavButtons({
  stepIndex,
  totalSteps,
  next,
  back,
  dismiss,
}: {
  stepIndex: number;
  totalSteps: number;
  next(): void;
  back(): void;
  dismiss(): void;
}) {
  const isLast = stepIndex === totalSteps - 1;

  return (
    <>
      <WalkthroughBackButton
        back={back}
        dismiss={dismiss}
        stepIndex={stepIndex}
      />
      <RedoButton
        hierarchy="primary"
        onClick={next}
        size="sm"
        text={isLast ? "Done" : "Next"}
      />
    </>
  );
});
